import { FC, useEffect } from 'react';
import { useLocalStorage } from 'usehooks-ts';
import { Navigate } from 'react-router-dom';
import { ACCESS_TOKEN_KEY, UNAUTHORIZED_REDIRECT } from '../../constants/config.ts';
import Routes from '../routes.enum.ts';
import { Children } from '../../constants/types/prop.types.ts';

const AccessTokenGuard: FC<Children> = ({ children }) => {
  const [accessToken] = useLocalStorage(ACCESS_TOKEN_KEY, '');
  const [redirectUrl, setRedirectUrl] = useLocalStorage(UNAUTHORIZED_REDIRECT, '');

  useEffect(() => {
    if (redirectUrl) setRedirectUrl('');
  }, [redirectUrl]);

  if (!accessToken) {
    return <Navigate to={redirectUrl || Routes.SignIn} replace />;
  }

  return children;
};

export default AccessTokenGuard;
